export class FailureHistory {
    [key: number]: FailureHistory;
    at: number = 0;
}